<template>
    <div class="contract-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">工作信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">合同公司:</el-col>
                            <el-col :span="7" class="col-n col">{{ base.contract_company_name }}</el-col>
                            <el-col :span="5" class="col">合同类型:</el-col>
                            <el-col :span="7" class="col-n col">{{ base.contract_name }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">首次合同起始日:</el-col>
                            <el-col :span="7" class="col-n col">{{ contractInfoForm.first_contracted_at }}</el-col>
                            <el-col :span="5" class="col">首次合同到期日:</el-col>
                            <el-col :span="7" class="col-n col">{{ contractInfoForm.first_contract_expired_at }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">现合同起始日:</el-col>
                            <el-col :span="7" class="col-n col">{{ contractInfoForm.now_contracted_at }}</el-col>
                            <el-col :span="5" class="col">现合同到期日:</el-col>
                            <el-col :span="7" class="col-n col">{{ contractInfoForm.now_contract_expired_at }}</el-col>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">合同期限:</el-col>
                            <el-col :span="7" class="col-n col">{{ base.term_name }}</el-col>
                            <el-col :span="5" class="col">续签次数:</el-col>
                            <el-col :span="7" class="col-n col">{{ contractInfoForm.num_of_renewals }}</el-col>
                        </el-row>
                    </div>
                    <div v-else>
                        <el-form ref="contractInfoForm" :model="contractInfoForm" label-width="115px" size="medium">
                            <el-form-item label="合同公司">
                                <el-select v-model="contractInfoForm.contract_company" placeholder="请选择" style="width: 100%"
                                    clearable filterable size="medium">
                                    <el-option label="上海优开信息科技有限公司" :value="1"></el-option>
                                    <el-option label="上海账六六信息科技有限公司" :value="2"></el-option>
                                    <el-option label="云上飕飕（上海）企业管理有限公司" :value="3"></el-option>
                                    <el-option label="鑫项云企业服务（上海）有限公司" :value="4"></el-option>
                                    <el-option label="优开财务顾问（上海）有限公司" :value="5"></el-option>
                                    <el-option label="畅享无忧财务顾问（上海）有限公司" :value="6"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="合同类型">
                                <el-select v-model="contractInfoForm.type" placeholder="请选择" style="width: 100%" clearable
                                    filterable size="medium">
                                    <el-option :value="1" label="固定期限劳动合同">
                                    </el-option>
                                    <el-option :value="2" label="无固定期限劳动合同">
                                    </el-option>
                                    <el-option :value="3" label="实习协议">
                                    </el-option>
                                    <el-option :value="4" label="劳务协议">
                                    </el-option>
                                    <el-option :value="5" label="劳务派遣合同">
                                    </el-option>
                                    <el-option :value="6" label="返聘协议">
                                    </el-option>
                                    <el-option :value="7" label="短期劳动合同">
                                    </el-option>
                                    <el-option :value="8" label="劳动合同">
                                    </el-option>
                                    <el-option :value="9" label="其他">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="首次合同起始日">
                                <el-date-picker v-model="contractInfoForm.first_contracted_at" type="date" unlink-panels
                                    value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="首次合同到期日">
                                <el-date-picker v-model="contractInfoForm.first_contract_expired_at" type="date"
                                    unlink-panels value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="现合同起始日">
                                <el-date-picker v-model="contractInfoForm.now_contracted_at" type="date" unlink-panels
                                    value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="现合同到期日">
                                <el-date-picker v-model="contractInfoForm.now_contract_expired_at" type="date" unlink-panels
                                    value-format="yyyy-MM-dd" style="width: 100%" size="medium">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="合同期限">
                                <el-select v-model="contractInfoForm.term" placeholder="请选择" style="width: 100%" clearable
                                    filterable size="medium">
                                    <el-option :value="1" label="6个月">
                                    </el-option>
                                    <el-option :value="2" label="12个月">
                                    </el-option>
                                    <el-option :value="3" label="24个月">
                                    </el-option>
                                    <el-option :value="4" label="36个月或以上">
                                    </el-option>
                                    <el-option :value="5" label="无">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="续签次数">
                                <el-input type="number" v-model.trim="contractInfoForm.num_of_renewals"
                                    clearable></el-input>
                            </el-form-item>
                            <el-form-item size="medium">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
export default {
    name: 'ContractInfo',
    mixins: [common],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            contractInfoForm: {
                contract_company: '',
                type: '',
                first_contracted_at: '',
                first_contract_expired_at: '',
                now_contracted_at: '',
                now_contract_expired_at: '',
                term: '',
                num_of_renewals: ''
            },
            isEdit: false,
            adminuserId: '',
            adminuserName: '',
            base: {
                contract_company_name: '',
                contract_name: '',
                term_name: '',
            }
        }
    },
    methods: {
        onSubmit() {
            this.contractInfoForm.admin_user_id = this.adminuserId
            this.$axios.put('api/api3_update_contractinfo', this.contractInfoForm).then(({ data }) => {
                if (data.code === 200) {
                    this.base.contract_company_name = data.data['contract_company_name']
                    this.base.contract_name = data.data['contract_name']
                    this.base.term_name = data.data['term_name']
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserContractInfo(admin_user_id) {
            this.resetForm()
            this.ysyMAdminUserContractInfoOptions = []
            this.ysyMGetAdminUserContractInfo(admin_user_id)
        },
        resetForm() {
            this.contractInfoForm.contract_company = ''
            this.contractInfoForm.type = ''
            this.contractInfoForm.first_contracted_at = ''
            this.contractInfoForm.first_contract_expired_at = ''
            this.contractInfoForm.now_contracted_at = ''
            this.contractInfoForm.now_contract_expired_at = ''
            this.contractInfoForm.term = ''
            this.contractInfoForm.num_of_renewals = ''

            this.base.contract_company_name = ''
            this.base.contract_name = ''
            this.base.term_name = ''
        },
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserContractInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminUserContractInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        this.contractInfoForm.contract_company = n.contract_company
                        this.base.contract_company_name = n.contract_company_name
                        this.contractInfoForm.type = n.type
                        this.base.contract_name = n.contract_name
                        this.contractInfoForm.first_contracted_at = n.first_contracted_at
                        this.contractInfoForm.first_contract_expired_at = n.first_contract_expired_at
                        this.contractInfoForm.now_contracted_at = n.now_contracted_at
                        this.contractInfoForm.now_contract_expired_at = n.now_contract_expired_at
                        this.contractInfoForm.term = n.term
                        this.base.term_name = n.term_name
                        this.contractInfoForm.num_of_renewals = n.num_of_renewals
                    }
                }
            },
        },
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/ContractInfo.vue